const DB_NAME = "Clubbable-Promoters-Groups";
const STORE_NAME = "Promoters_SeenUnseen_Groups";

function openDb(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, 1);
    request.onerror = () => reject(request.error);
    request.onupgradeneeded = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: "id" });
      }
    };
    request.onsuccess = () => resolve(request.result);
  });
}

export interface SeenGroupEntry {
  id: string;
  partyDate: Date;
}

export async function getSeenGroupIds(): Promise<SeenGroupEntry[]> {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, "readwrite");
    const store = tx.objectStore(STORE_NAME);
    const request = store.getAll();

    request.onsuccess = () => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const result: SeenGroupEntry[] = [];

      for (const entry of request.result) {
        const partyDate = new Date(entry.partyDate);
        if (partyDate >= today) {
          result.push({ id: entry.id, partyDate: entry.partyDate });
        } else {
          store.delete(entry.id);
        }
      }

      tx.oncomplete = () => {
        db.close();
        resolve(result);
      };
    };

    request.onerror = () => {
      db.close();
      reject(request.error);
    };
  });
}

export async function markGroupAsSeen(id: string, partyDate: Date): Promise<void> {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, "readwrite");
    const store = tx.objectStore(STORE_NAME);
    store.put({ id, partyDate });

    tx.oncomplete = () => {
      db.close();
      resolve();
    };
    tx.onerror = () => {
      db.close();
      reject(tx.error);
    };
  });
}
